/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_CloseInputs */

const en_shared_close = /** @type {(inputs: Shared_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const nl_shared_close = /** @type {(inputs: Shared_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

/** @type {(inputs: Shared_CloseInputs) => LocalizedString} */
const de_shared_close = en_shared_close;

/** @type {(inputs: Shared_CloseInputs) => LocalizedString} */
const es_shared_close = en_shared_close;

/** @type {(inputs: Shared_CloseInputs) => LocalizedString} */
const fr_shared_close = en_shared_close;

/** @type {(inputs: Shared_CloseInputs) => LocalizedString} */
const it_shared_close = en_shared_close;

/** @type {(inputs: Shared_CloseInputs) => LocalizedString} */
const pt_br2_shared_close = en_shared_close;

/** @type {(inputs: Shared_CloseInputs) => LocalizedString} */
const pl_shared_close = en_shared_close;

/** @type {(inputs: Shared_CloseInputs) => LocalizedString} */
const hu_shared_close = en_shared_close;

/** @type {(inputs: Shared_CloseInputs) => LocalizedString} */
const ro_shared_close = en_shared_close;

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Shared_CloseInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_close = /** @type {((inputs?: Shared_CloseInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_CloseInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_close(inputs)
	if (locale === "de") return de_shared_close(inputs)
	if (locale === "es") return es_shared_close(inputs)
	if (locale === "fr") return fr_shared_close(inputs)
	if (locale === "nl") return nl_shared_close(inputs)
	if (locale === "it") return it_shared_close(inputs)
	if (locale === "pt-BR") return pt_br2_shared_close(inputs)
	if (locale === "pl") return pl_shared_close(inputs)
	if (locale === "hu") return hu_shared_close(inputs)
	return ro_shared_close(inputs)
});
export { shared_close as "shared.close" }